module.exports = __webpack_public_path__ + "img/wifi.c6cc8782.png";